<template>
	<div class="divcargo" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }" v-if="isload">
		<el-form>
			<el-row>
				<maininfo :ref="'maininfo_'+l_id" :item="item" :l_id="l_id" :layout="layout"></maininfo>
			</el-row>
		</el-form>
		<div v-if="!isdialog">
			<el-row class="footerhandler" v-if="!btndisabled&&!isdetail">
				<el-col :span="5" style="color:transparent;">1</el-col>
				<el-col :span="4" class="submitBtn"><div @click="saveorder">{{$lang.label.public.savebtn}}</div></el-col>
				<el-col :span="4" class="submitBtn_cancel"><div @click="cancel">{{$lang.label.public.cancel}}</div></el-col>
			</el-row>
		</div>
		<div v-else style="margin-top:20px">
			<el-row>
				<el-col :span="9" style="color:transparent">1</el-col>
				<el-col :span="8">
					<el-button type="success" size="mini" @click="saveorder">{{$lang.label.public.savebtn}}</el-button>
					<el-button size="mini" @click="cancel" style="margin-left:10px">{{$lang.label.public.cancel}}</el-button>
				</el-col>
			</el-row>
		</div>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import maininfo from '@/components/tools/maininfo.vue';
export default {
	components: {
		maininfo
	},
	props: {
		urlparam: {
			type: Object,
			default:function(){
				return {
					
				};
			}
		},
		item:{
			type: Object,
			default:function(){
				return {
					
				};
			}
		}
	},
	data() {
		return {
			pageparam: {},
			curpkval: '',
			iscopy: 0,
			type: '',
			orderinfo:'',
			l_id:'',
			isedit:'',
			btndisabled:false,
			isload:false,
			addcargo_lang:{},
			windowHeight: window.innerHeight - 120,
			t_id:'',
			isdetail:false,
			isdialog:false,
			layout:'0' //0-横向  1-纵向
		};
	},
	created() {
		if(this.item.l_tabevent!=''&&this.item.l_tabevent!=undefined)
			this.l_id=this.item.l_tabevent;
		else
			this.l_id=this.item.l_id;
	},
	mounted() {
		import('../../static/' + this.$theme + '/style/bodybase.scss');
		this.init();
	},
	methods:{
		init(){
			debugger
			if(this.item!=undefined){
				if(this.item.isdialog!=undefined)
				{
					this.isdialog=this.item.isdialog;
					if(this.isdialog)
						this.windowHeight=300;
				}
				if(this.item.layout!=undefined)
					this.layout=this.item.layout;
			}
			if (this.urlparam != undefined) {
				this.type=this.item.l_tablename;
				this.pageparam = this.urlparam;
				if (this.urlparam.pkval != undefined) {
					this.curpkval = this.urlparam.pkval;
					if (this.urlparam.iscopy != undefined) {
						this.iscopy = this.urlparam.iscopy;
					}
				}
				if(this.urlparam.isedit!=undefined)
					this.isedit=this.urlparam.isedit;	
				if(this.urlparam.isdetail!=undefined)
					this.isdetail=this.urlparam.isdetail;
				
			}
			if(this.curpkval!='')//加载账单
				this.GetOrderInfo();
			else
				this.GetPageLayout();
			//this.loadlanguage();
		},
		// loadlanguage(){
		// 	var that=this;
		// 	this.$public.GetLanguageByMode('addcargo',this).then(res=>{
		// 		if(res.state=='1')
		// 			that.addcargo_lang=that.$lang.label.addcargo;
		// 		if(this.curpkval!='')//加载账单
		// 			this.GetOrderInfo();
		// 		else
		// 			this.GetPageLayout();
		// 	});
		// },
		GetOrderInfo(){
			debugger
			var that=this;
			this.$tool.loading(that.$lang.label.public.loading, this.divclass);
			var paraminfo={
				pkval:this.curpkval,
				l_id:this.l_id
			}
			this.$apipost.get.GetOrderInfoByLid({paraminfo:paraminfo}).then(res => {
				this.$tool.loadingclose();
				if (res != '') {
					//debugger
					that.orderinfo = res;
					that.GetPageLayout();
				} else
					this.$tool.message(that.$lang.label.public.getinfofailed, "0");
			});
		},
		GetPageLayout(){
			var that = this;
			//debugger
			//this.truncatepage();
			this.$tool.loading(that.$lang.label.public.loading, this.divclass);
			//判断是哪种类型的下单功能,显示对应组件
			this.$apipost.get.GetTransFormat({
				p_mode: this.type
			}).then(res => {
				this.$tool.loadingclose();
				var t_id="",pagetranscol="",syscol="";
				if (res.state == '1') {
					if (res.set != undefined) {
						if(res.set.t_id!=undefined)
						{
							t_id = res.set.t_id;
							pagetranscol=res.set.pagetranscol;
							syscol= res.set.t_syscol
						}
					}
					var list=[];
					if(t_id==''&&res.list!=undefined){
						list = res.list.filter(function(re) {
							return re.t_type == that.type;
						});
						if(list.length>0){
							t_id = list[0].t_id;
							pagetranscol=list[0].pagetranscol;
							syscol= list[0].t_syscol;
						}
					}
					if(t_id!=''){
						that.t_id=t_id;
						that.isload=true;
						that.pagetranscol=pagetranscol;
						if(that.orderinfo!='')
							that.orderinfo = that.$tool.TransOrderInfo(pagetranscol, that);
						
						that.$nextTick(function(){
							that.$refs['maininfo_'+that.l_id].init({
								pkval:that.curpkval,
								iscopy:that.iscopy,
								type:that.type,
								orderinfo:that.orderinfo,
								syscol:syscol,
								t_id: t_id,
								isdetail:that.isdetail,
								});
						});
					}
				}
			});
		},
		saveorder() {
			var that=this;
			//debugger
			var orderinfo=this.$tool.getOrderinfo(this.$refs['maininfo_'+this.l_id]._data,this.p_no,this);
			if(orderinfo!=''){
				//debugger
				orderinfo.u_userid=localStorage.getItem('userid');
				orderinfo.t_id=that.t_id;
				orderinfo.editid=this.curpkval;
				this.btnhidden=true;
				this.$tool.loading(that.$lang.label.public.saving, this.divclass);
				this.$apipost.post.SaveInfo({ paraminfo: orderinfo }).then(res => {
					this.$tool.loadingclose();
					this.btnhidden=false;
					if (res.state == '1') {
						this.$tool.message(that.$lang.label.public.savesuccess, "1");
						setTimeout(function(){
							that.cancel();
						},1000);
					}
					else
						this.$tool.message(res.message, "0");
						//this.$tool.message(that.baojia_lang[res.message], "0");
				});
			}
		},
		cancel(){
			if(this.isdialog)
				this.$parent.$parent.$parent.showdialog=false;
			else 
				Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		},
	}
}
</script>

<style>
</style>